import actions, { configurationCodes } from './constants';

export const applyConfigurations = (results) => ({
  type: actions.APPLY_CONFIGURATIONS,
  category: 'all',
  results,
});

export const showAutoApproval = () => ({
  type: actions.SHOW_AUTO_APPROVAL_CONFIGURATION,
});

export const hideAutoApproval = () => ({
  type: actions.HIDE_AUTO_APPROVAL_CONFIGURATION,
});

export const updateAutoApprovalSuccess = (category, result) => ({
  type: actions.UPDATE_CONFIGURATION_SUCCESS, category, code: configurationCodes.DEFAULT_APPROVAL, result,
});

export const toggleAutoApprovalConfiguration = (category) => ({
  type: actions.TOGGLE_AUTO_APPROVAL_CONFIGURATION,
  category,
  code: configurationCodes.DEFAULT_APPROVAL,
});

export const updateDefaultRoleConfiguration = (category, role) => ({
  type: actions.UPDATE_DEFAULT_ROLE_CONFIGURATION,
  category,
  code: configurationCodes.DEFAULT_ROLE,
  role,
});

export const updateConfigurationProperties = (category, code, properties) => ({
  type: actions.UPDATE_CONFIGURATION_PROPERTIES,
  category,
  code,
  properties,
});

export const updateDefaultRoleSuccess = (category, result) => ({
  type: actions.UPDATE_CONFIGURATION_SUCCESS,
  category,
  code:
  configurationCodes.DEFAULT_ROLE,
  result,
});

export const updateConfigurationError = (category, code, error) => ({
  type: actions.UPDATE_CONFIGURATION_ERROR,
  category,
  code,
  error,
});

export const fetchConfiguration = (category, code) => ({
  type: actions.FETCH_CONFIGURATION,
  category,
  code,
});

export const showConfigurationSuccess = (category, code, result) => ({
  type: actions.SHOW_CONFIGURATION_SUCCESS,
  category,
  code,
  result,
});

export const showConfigurationError = (category, code, error) => ({
  type: actions.SHOW_CONFIGURATION_ERROR,
  category,
  code,
  error,
});
